import * as React from "react";
const SvgAntillesFlag = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", viewBox: "0 0 513 342", ...props }, /* @__PURE__ */ React.createElement("g", { id: "surface1" }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 513, height: 342, style: {
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1,
  stroke: "none"
} }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(86.27451%,9.019608%,11.372549%)",
  fillOpacity: 1
}, d: "M 199.5 0 L 313.5 0 L 313.5 342 L 199.5 342 Z M 199.5 0 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(0.392157%,16.470588%,52.941176%)",
  fillOpacity: 1
}, d: "M 0 114 L 513 114 L 513 228 L 0 228 Z M 0 114 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 256.5 118.75 L 252.097656 132.304688 L 258.871094 134.503906 Z M 256.5 118.75 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 256.5 118.75 L 260.902344 132.304688 L 254.128906 134.503906 Z M 256.5 118.75 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 270.050781 128.597656 L 255.800781 128.597656 L 255.800781 135.722656 Z M 270.050781 128.597656 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 270.050781 128.597656 L 258.523438 136.972656 L 254.335938 131.207031 Z M 270.050781 128.597656 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 242.949219 128.597656 L 254.476562 136.972656 L 258.664062 131.207031 Z M 242.949219 128.597656 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 242.949219 128.597656 L 257.199219 128.597656 L 257.199219 135.722656 Z M 242.949219 128.597656 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 264.875 144.527344 L 260.472656 130.976562 L 253.695312 133.175781 Z M 264.875 144.527344 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 264.875 144.527344 L 253.347656 136.152344 L 257.535156 130.390625 Z M 264.875 144.527344 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 248.125 144.527344 L 259.652344 136.152344 L 255.464844 130.390625 Z M 248.125 144.527344 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 248.125 144.527344 L 252.527344 130.976562 L 259.304688 133.175781 Z M 248.125 144.527344 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 332.5 150.230469 L 328.097656 163.785156 L 334.871094 165.984375 Z M 332.5 150.230469 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 332.5 150.230469 L 336.902344 163.785156 L 330.128906 165.984375 Z M 332.5 150.230469 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 346.050781 160.078125 L 331.800781 160.078125 L 331.800781 167.203125 Z M 346.050781 160.078125 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 346.050781 160.078125 L 334.523438 168.453125 L 330.335938 162.6875 Z M 346.050781 160.078125 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 318.949219 160.078125 L 330.476562 168.453125 L 334.664062 162.6875 Z M 318.949219 160.078125 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 318.949219 160.078125 L 333.199219 160.078125 L 333.199219 167.203125 Z M 318.949219 160.078125 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 340.875 176.011719 L 336.472656 162.457031 L 329.695312 164.660156 Z M 340.875 176.011719 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 340.875 176.011719 L 329.347656 167.632812 L 333.535156 161.867188 Z M 340.875 176.011719 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 324.125 176.011719 L 335.652344 167.632812 L 331.464844 161.867188 Z M 324.125 176.011719 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 324.125 176.011719 L 328.527344 162.457031 L 335.304688 164.660156 Z M 324.125 176.011719 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 287.980469 194.75 L 283.578125 208.304688 L 290.351562 210.503906 Z M 287.980469 194.75 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 287.980469 194.75 L 292.382812 208.304688 L 285.609375 210.503906 Z M 287.980469 194.75 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 301.53125 204.597656 L 287.28125 204.597656 L 287.28125 211.722656 Z M 301.53125 204.597656 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 301.53125 204.597656 L 290.003906 212.972656 L 285.816406 207.207031 Z M 301.53125 204.597656 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 274.425781 204.597656 L 285.957031 212.972656 L 290.144531 207.207031 Z M 274.425781 204.597656 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 274.425781 204.597656 L 288.675781 204.597656 L 288.675781 211.722656 Z M 274.425781 204.597656 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 296.355469 220.527344 L 291.953125 206.976562 L 285.175781 209.175781 Z M 296.355469 220.527344 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 296.355469 220.527344 L 284.828125 212.152344 L 289.015625 206.390625 Z M 296.355469 220.527344 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 279.605469 220.527344 L 291.132812 212.152344 L 286.945312 206.390625 Z M 279.605469 220.527344 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 279.605469 220.527344 L 284.007812 206.976562 L 290.785156 209.175781 Z M 279.605469 220.527344 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 180.5 150.230469 L 184.902344 163.785156 L 178.128906 165.984375 Z M 180.5 150.230469 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 180.5 150.230469 L 176.097656 163.785156 L 182.871094 165.984375 Z M 180.5 150.230469 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 166.949219 160.078125 L 181.199219 160.078125 L 181.199219 167.203125 Z M 166.949219 160.078125 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 166.949219 160.078125 L 178.476562 168.453125 L 182.664062 162.6875 Z M 166.949219 160.078125 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 194.050781 160.078125 L 182.523438 168.453125 L 178.335938 162.6875 Z M 194.050781 160.078125 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 194.050781 160.078125 L 179.800781 160.078125 L 179.800781 167.203125 Z M 194.050781 160.078125 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 172.125 176.011719 L 176.527344 162.457031 L 183.304688 164.660156 Z M 172.125 176.011719 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 172.125 176.011719 L 183.652344 167.632812 L 179.464844 161.867188 Z M 172.125 176.011719 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 188.875 176.011719 L 177.347656 167.632812 L 181.535156 161.867188 Z M 188.875 176.011719 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 188.875 176.011719 L 184.472656 162.457031 L 177.695312 164.660156 Z M 188.875 176.011719 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 225.019531 194.75 L 229.421875 208.304688 L 222.648438 210.503906 Z M 225.019531 194.75 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 225.019531 194.75 L 220.617188 208.304688 L 227.390625 210.503906 Z M 225.019531 194.75 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 211.46875 204.597656 L 225.71875 204.597656 L 225.71875 211.722656 Z M 211.46875 204.597656 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 211.46875 204.597656 L 222.996094 212.972656 L 227.183594 207.207031 Z M 211.46875 204.597656 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 238.574219 204.597656 L 227.042969 212.972656 L 222.855469 207.207031 Z M 238.574219 204.597656 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 238.574219 204.597656 L 224.324219 204.597656 L 224.324219 211.722656 Z M 238.574219 204.597656 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 216.644531 220.527344 L 221.046875 206.976562 L 227.824219 209.175781 Z M 216.644531 220.527344 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 216.644531 220.527344 L 228.171875 212.152344 L 223.984375 206.390625 Z M 216.644531 220.527344 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 233.394531 220.527344 L 221.867188 212.152344 L 226.054688 206.390625 Z M 233.394531 220.527344 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(100%,100%,100%)",
  fillOpacity: 1
}, d: "M 233.394531 220.527344 L 228.992188 206.976562 L 222.214844 209.175781 Z M 233.394531 220.527344 " })));
export default SvgAntillesFlag;
